import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

const UPDATE_EVENT_TICKET = gql`
  mutation UpdateEventTicket($input: UpdateEventTicketInput!) {
    updateEventTicket(input: $input) {
      id
      event_id
      name
      price
      track_price
      type
      start_date
      end_date
      color_code
      limit
      description
      description_image_id
      description_image
      description_video
      fee_dollar
      fee_percent
      pos_fee_dollar
      pos_fee_percent
      visibility
      is_featured
      featured_text
      category_id
      reserved_seat
      reserved_seat_category
      reserved_seat_prefix
      reserved_seat_section
      chart_id
      set_member_number
      prefix_text
      suffix_text
      last_member_number
      order
      sale_start
      sale_end
      on_sale_time
      off_sale_time
      associated_tickets {
        id
        name
        quantity
      }
    }
  }
`;

export function useUpdateEventTicket() {
  const [updateEventTicketMutation, { loading, error }] =
    useMutation(UPDATE_EVENT_TICKET);

  const updateEventTicket = useCallback(
    async (input) => {
      const response = await updateEventTicketMutation({
        variables: { input },
      });
      return response;
    },
    [updateEventTicketMutation]
  );

  return { updateEventTicket, loading, error };
}
